export default "__VITE_ASSET__d1aa2f10__"